import { observer } from 'mobx-react';

import { useRouter } from 'next/router';

import { useGlobalContext } from 'hooks';
import { useCurrentUserQuery } from 'hooks/query-hooks/users/useUserQuery';

import NoAccess from 'components/NoAccess';
import Page from 'components/Page';
import AttorneyHome from 'components/pages/home/AttorneyHome';
import PanelHome from 'components/pages/home/PanelHome';
import PlaceHolder from 'components/pages/home/PlaceHolder';

const HomePage = () => {
  const { firm } = useGlobalContext();
  const router = useRouter();

  const { data: user, isFetching } = useCurrentUserQuery();

  if (isFetching || (!user.isPanelUser && user.firm && firm.loading)) {
    return <PlaceHolder />;
  }

  // The user is not a registered panel rep or panel user and they are not associated with a firm, do not allow access.
  if (!isFetching && !user.isPanelUser && !user.firm) {
    return <NoAccess />;
  }

  if (!isFetching && user.isAttorneyUser && !user.hasRequiredProfile) {
    router.replace('/create-attorney-profile');
    return null;
  }

  if (!isFetching && user.isUnreviewedAttorney) {
    return <NoAccess forAttorneyUnderReview />;
  }

  return (
    <Page title="Home" showBackButton={false}>
      {user.isPanelUser ? <PanelHome /> : <AttorneyHome />}
    </Page>
  );
};

export default observer(HomePage);
